import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { Typography, List, ListItem, ListItemText } from "@mui/material";
import CottageOutlinedIcon from "@mui/icons-material/CottageOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PsychologyIcon from "@mui/icons-material/Psychology";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import { Link } from "react-router-dom";

const HeaderWrapper = styled.div`
  z-index: 99999;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-shadow: 0 0.125rem 0.3125rem rgba(34, 34, 34, 0.1);
  box-shadow: 0 0.125rem 0.3125rem rgba(34, 34, 34, 0.2);
  background: linear-gradient(45deg, #de9f9f, #E8A2A2);
  padding: 20px 5%;
`;

const listStyle = {
  display: "flex", // Set the list to display flex
  flexDirection: "row", // Make the list items align horizontally
  padding: 0, // Remove default padding
  justifyContent: "center", // Align items to the right
  marginLeft: "350px",
};

const listItemWrap = {
  flex: 1, // Make each list item take up equal space
  display: "flex",
  alignItems: "center", // Center the contents vertically
  justifyContent: "center", // Center the contents horizontally
};

const textStyle = {
  display: "none",
  "&:hover": {
    display: "block",
  },
};
const iconWrap = {
  fontSize: "2rem", // Adjust icon size as needed
};

const LinkWrapper = styled(Link)`
  color: #fff;
  text-decoration: none;
`;

const MenuWrapper = styled.div``;

const Header: FunctionComponent = () => {
  return (
    <HeaderWrapper>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#fff", margin: "0px" , fontFamily:"Cursive"}}
      >
        Hina Humayun
      </Typography>

      <MenuWrapper>

<List sx={listStyle} component="nav">
<div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", gap:"50px"}}>
  <LinkWrapper to="#home">
    <ListItem sx={listItemWrap}>
      <CottageOutlinedIcon sx={iconWrap} />
      <ListItemText primary="Home" sx={textStyle} />
    </ListItem>
  </LinkWrapper>
  <LinkWrapper to="#about">
    <ListItem sx={listItemWrap}>
      <AccountCircleIcon sx={iconWrap} />
      <ListItemText primary="About" sx={textStyle} />
    </ListItem>
  </LinkWrapper>
  <LinkWrapper to="#skills">
    <ListItem sx={listItemWrap}>
      <PsychologyIcon sx={iconWrap} />
      <ListItemText primary="Skills" sx={textStyle} />
    </ListItem>
  </LinkWrapper>
  <LinkWrapper to="#experience">
    <ListItem sx={listItemWrap}>
      <ManageAccountsIcon sx={iconWrap} />
      <ListItemText primary="Experience" sx={textStyle} />
    </ListItem>
  </LinkWrapper>
  <LinkWrapper to="#contact">
    <ListItem sx={listItemWrap}>
      <ContactMailIcon sx={iconWrap} />
      <ListItemText primary="Contact" sx={textStyle} />
    </ListItem>
  </LinkWrapper>
  </div>
</List>
</MenuWrapper>
    </HeaderWrapper>
  );
};

export default Header;
